import React, { useState } from 'react';
import { colors, typography, spacing, components, transitions } from '../styles/shared';
import { AVERY_FORMATS } from '../utils/labelFormats';
import { Download } from 'lucide-react';

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  dialog: {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: spacing[6],
    width: '100%',
    maxWidth: '600px',
    maxHeight: '90vh',
    overflowY: 'auto',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  },
  title: {
    ...typography.h3,
    color: colors.gray[900],
    marginBottom: spacing[4],
  },
  description: {
    ...typography.body1,
    color: colors.gray[600],
    marginBottom: spacing[6],
  },
  formatList: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing[3],
    marginBottom: spacing[6],
  },
  formatOption: {
    display: 'flex',
    alignItems: 'center',
    padding: spacing[4],
    border: `1px solid ${colors.gray[200]}`,
    borderRadius: '6px',
    cursor: 'pointer',
    transition: transitions.smooth,
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: colors.gray[50],
      borderColor: colors.gray[300],
    },
  },
  formatInfo: {
    flex: 1,
  },
  formatName: {
    ...typography.body1,
    color: colors.gray[900],
    fontWeight: '500',
    marginBottom: '2px',
  },
  formatDescription: {
    ...typography.body2,
    color: colors.gray[600],
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: spacing[3],
  },
  button: {
    ...components.button.base,
    display: 'flex',
    alignItems: 'center',
    gap: spacing[2],
  },
  cancelButton: {
    ...components.button.secondary,
    display: 'flex',
    alignItems: 'center',
    gap: spacing[2],
  },
  downloadButton: {
    ...components.button.primary,
    display: 'flex',
    alignItems: 'center',
    gap: spacing[2],
  },
};

const PrintFormatDialog = ({ onClose, onDownload }) => {
  const [selectedFormat, setSelectedFormat] = useState('5160');

  const handleDownload = () => {
    const format = {
      ...AVERY_FORMATS[selectedFormat],
      type: 'avery',
      id: selectedFormat
    };
    onDownload(format);
    onClose();
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.dialog} onClick={e => e.stopPropagation()}>
        <h2 style={styles.title}>Choose Avery Label Format</h2>
        <p style={styles.description}>
          Select a label format that matches your Avery label sheet.
        </p>

        <div style={styles.formatList}>
          {Object.entries(AVERY_FORMATS).map(([id, format]) => (
            <button
              key={id}
              style={{
                ...styles.formatOption,
                ...(selectedFormat === id && {
                  borderColor: colors.primary[500],
                  backgroundColor: colors.primary[50],
                }),
              }}
              onClick={() => setSelectedFormat(id)}
            >
              <div style={styles.formatInfo}>
                <div style={styles.formatName}>{format.name}</div>
                <div style={styles.formatDescription}>
                  {format.description} • {format.labelsPerSheet} labels per sheet
                </div>
              </div>
            </button>
          ))}
        </div>

        <div style={styles.buttons}>
          <button style={{ ...styles.button, ...styles.cancelButton }} onClick={onClose}>
            Cancel
          </button>
          <button style={{ ...styles.button, ...styles.downloadButton }} onClick={handleDownload}>
            <Download size={18} />
            Download
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrintFormatDialog; 